<template>
    <el-row class="pinned-page">
        <el-col :xs="24" :sm="16" :sm-push="4">
            <el-card class="box-card">
                <div slot="header" class="clearfix flex align-center">
                    <span class="pinned-title">置顶活动列表</span>
                    <el-tag v-if="loaded && totalCount" size="mini" type="info" class="margin-left hidden-xs-only">共 {{totalCount}} 个活动</el-tag>
                </div>

                <el-alert v-if="loaded && !totalCount"
                          title="暂无置顶活动"
                          description="可在活动设置 - 其它功能 - 活动置顶中开启置顶"
                          type="info" :closable="false" show-icon>
                </el-alert>

                <el-collapse v-model="activePositions">
                    <el-collapse-item v-for="(pos, idx) in positions"
                                      :key="idx"
                                      :name="idx+1"
                                      :title="posTitle(idx)">
                        <el-descriptions :column="1" border size="mini">
                            <el-descriptions-item v-for="act in pos" :key="act.activityId">
                                <template slot="label">
                                    <span class="act-id">ID:{{act.activityId}}</span>
                                </template>
                                <div class="act-row">
                                    <span class="act-name" @click="actJump(act)">{{act.activityName}}</span>
                                </div>
                                <div class="act-time flex align-center flex-wrap">
                                    <span>开始：{{fmtTime(act.pinnedStartTime)}}</span>
                                    <el-tag size="mini" :type="timeType(act.pinnedEndTime)" class="margin-left">
                                        结束：{{fmtTime(act.pinnedEndTime)}}
                                    </el-tag>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>
                </el-collapse>
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
  import App from '../../util/comfun'
  const CN=['','一','二','三','四','五','六','七','八','九','十']
  export default {
    data(){
      return {
        options:{},
        loaded:false,
        positions:[],          // positions[0]~[9] 对应第一位~第十位，每个元素是活动数组
        activePositions:[],    // 展开的位置 name 数组（有活动的位置默认展开）
      }
    },
    computed:{
      totalCount(){
        return this.positions.reduce((s,p)=>s+p.length,0)
      },
    },
    methods:{
      posTitle(idx){
        let n=idx+1, cnt=this.positions[idx].length
        return '第'+CN[n]+'位'+(cnt?('（'+cnt+'个活动）'):'（暂无）')
      },
      // 跳转该活动设置页：复用当前页 options（含 token），追加 activityId
      actJump(act){
        let opts=Object.assign({}, this.options, {activityId: act.activityId})
        this.$router.push('/tools/activity/'+encodeURIComponent(encodeURIComponent(JSON.stringify(opts))))
      },
      // 秒级时间戳 → yyyy-MM-dd HH:mm:ss；兼容字符串与 13 位毫秒
      fmtTime(ts){
        if(ts==null || ts==='') return '-'
        let n=Number(ts)
        if(n>1e12) n=Math.floor(n/1000)
        return App.unixtoTime(n,'YYYY-MM-DD HH:II:SS')
      },
      timeType(ts){ // 已过期的结束时间置灰
        if(ts==null || ts==='') return 'info'
        let n=Number(ts)
        if(n>1e12) n=Math.floor(n/1000)
        return n < Math.floor(Date.now()/1000) ? 'info' : 'success'
      },
      async loadList(){
        let res=await App.demand('/admin/activity/loadPinnedActivityList','GET')
        if(res.code!=200) return this.$message.error('获取置顶活动列表失败')
        this.normalize(res.data)
        // 有活动的位置默认全部展开，空位置收起
        this.activePositions=this.positions.map((p,i)=>(p.length?i+1:0)).filter(Boolean)
        this.loaded=true
      },
      normalize(data){
        let map={}
        ;(data||[]).forEach(act=>{
          let n=Number(act.orderNum)
          if(n>=1&&n<=10) (map[n]=map[n]||[]).push(act)
        })
        this.positions=Array.from({length:10},(_,i)=>map[i+1]||[])
      },
    },
    mounted(){
      try{
        this.options=JSON.parse(decodeURIComponent(decodeURIComponent(this.$route.params.options)))
        if(this.options.token) wxlite.setStorageSync('token',this.options.token)
      }catch(e){ console.log(e) }
      this.loadList()
    },
  }
</script>

<style>
    @import 'element-ui/lib/theme-chalk/display.css';
    .pinned-title{font-weight:600;font-size:15px;}
    .act-id{color:#909399;font-size:12px;white-space:nowrap;}
    .act-name{color:#409EFF;font-weight:600;cursor:pointer;}
    .act-row{margin-bottom:4px;}
    .act-time{color:#606266;font-size:12px;}
    .pinned-page{padding:10px;}
    @media (max-width:768px){
        .pinned-page{padding:5px;}
        .el-collapse-item__content{padding-bottom:8px;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/tools/pinned-activity.vue